import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { lazyReadOcsSettings } from 'owa-ocs-service-gql';
import { isFeatureEnabled } from 'owa-feature-flags';
import { updateShouldExpandAllItemPartsMutator } from '../mutators/updateShouldExpandAllItemParts';
let isExpandAllPreferenceInitialized: boolean;
export default async function initializeExpandItemPartsPreference() {
    if (isFeatureEnabled('rp-expand-all') && !isExpandAllPreferenceInitialized) {
        const expandAllItemPartsSetting = await lazyReadOcsSettings.importAndExecute(
            getGlobalSettingsAccountMailboxInfo(),
            'GLOBAL',
            ['mail_reading_pane_expand_itemparts']
        );
        if (expandAllItemPartsSetting?.[0]) {
            updateShouldExpandAllItemPartsMutator(
                JSON.parse(expandAllItemPartsSetting[0].value) ?? false
            );
            isExpandAllPreferenceInitialized = true;
        }
    }
}
